module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ppsZFF/tc-custom/9781607050285.jpg?1737666957045",
      "alt": "This image is the cover for the book Simply Stars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Simply Stars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Learn to make stunning star quilts using squares, rectangles, triangles, and diamonds with this comprehensive guide by the host of "), _c('i', [_vm._v("The Quilt Show")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Simply Stars")]), _vm._v(", Alex Anderson introduces quilters of all skill levels to the world of star quilts, where pattern possibilities are as vast as the night sky. Alex covers the major types of star patterns, such as Stars Made of Squares and Triangles and Stars Made of Diamonds and Y Seams. Covering them in order of difficulty from beginner to advances, Alex offers several examples of each type. With foolproof techniques, Alex’s student-tested shortcuts, and exciting fabric combinations, you can start making quilts that sparkle.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alex Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alex Anderson Bio: Alex Anderson seeks to educate, inspire, entertain, and grow today’s quilting community. A longtime host of the TV show Simply Quilts, she is also executive producer and co-host of the web TV’s The Quilt Show with Ricky Tims. Alex lives in Northern California. alexandersonquilts.com and thequiltshow.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0